import { getRouteApi } from "@tanstack/react-router";
import { getApiProgram } from "~/lib/utils";


export function useProgram() {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
    const { program } = routeApi.useParams();
    const apiProgram = getApiProgram(program ?? "");

    return {
        program,
        apiProgram
    }
}